<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <v-main
    id="pages"
  >
    <div
      class="d-flex"
      style="height: 100%;position: relative;"
    >
      <div style="position: fixed;right: 16px;top: 16px; z-index: 1">
        <language-switcher

          :current-locale-code="currentLocaleCode"
          :locales="$i18n.messages"
          @language-change="changeLanguage"
        />
      </div>

      <div
        class="hidden-sm-and-down"
        style="width: 50%;background-color: #f1f5f9;height: 100%"
      >
        <div
          class="d-flex flex-column align-center justify-center text-center pa-8"
          style="height: 100%"
        >
          <primary-logo-display />
        </div>
      </div>
      <div
        class="hidden-sm-and-down"
        style="width: 50%"
      >
        <router-view />
      </div>
      <div
        class="hidden-md-and-up"
        style="width: 100%"
      >
        <router-view />
      </div>
    </div>
  </v-main>
</template>

<script>
import PrimaryLogoDisplay from '@/views/widget/uiComponent/PrimaryLogoDisplay.vue'
import LanguageSwitcher from '@/views/widget/commonLogic/LanguageSwitcher.vue'
import { changeLanguage, Remember } from '@/model/global/GlobalSettings'

export default {
  name: 'PagesCoreView',
  components: {
    LanguageSwitcher,
    PrimaryLogoDisplay
  },
  data: () => ({}),
  methods: {
    changeLanguage (locale) {
      Remember.locale = locale
      this.$i18n.locale = Remember.locale
      changeLanguage(locale)
    }
  },
  computed: {
    currentLocaleCode () {
      return this.$i18n.locale
    }
  }
}
</script>
